<!--<div class="sidebar">
  <ul class="navbar-nav">
    <li *ngIf="userIsAuthenticated" class="nav-item">
      <a class="nav-link active" aria-current="page" routerLink="/"
        >Rol: {{ userRole }} ({{ userID }})</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        routerLink="/"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }"
        >Home</a
      >
    </li>
    <li *ngIf="!userIsAuthenticated" class="nav-item">
      <a
        class="nav-link"
        routerLink="/iniciar-sesion"
        [routerLinkActive]="['active']"
        >Iniciar sesión</a
      >
    </li>
    <li *ngIf="!userIsAuthenticated" class="nav-item">
      <a class="nav-link" routerLink="/registro" [routerLinkActive]="['active']"
        >Registrarse</a
      >
    </li>
    <li *ngIf="userIsAuthenticated" class="nav-item">
      <a class="nav-link" routerLink="/platos" [routerLinkActive]="['active']"
        >Platos</a
      >
    </li>
    <li *ngIf="userIsAuthenticated && userRole == 'admin'" class="nav-item">
      <a class="nav-link" routerLink="/usuarios" [routerLinkActive]="['active']"
        >Usuarios</a
      >
    </li>
    <li *ngIf="userIsAuthenticated" class="nav-item">
      <a class="nav-link" (click)="onLogout()">Cerrar sesión</a>
    </li>
  </ul>
</div>-->
<div class="sidebar-container">
  <div class="sidebar-logo container d-flex">
    <!--<div class="justify-content-center align-self-center">
      <strong>Cocina</strong>&nbsp;sin recetas&nbsp;&nbsp;<i
        class="fa fa-lemon-o"
      ></i>
    </div>-->
    <img src="../../../assets/img/cookadhoc-horizontal.png" alt="CookAdHoc">
  </div>
  <ul class="sidebar-navigation">
    <app-nav-elements></app-nav-elements>
  </ul>
</div>
